export default "__VITE_ASSET__B80yly0F__"